module.exports = __webpack_public_path__ + "media/images/appLogo-4ef2278d9e5eb71ffece136c417739ce.png";